export default __webpack_public_path__ + "static/media/google-tag-manager.d7280e24.png";